import React, { Component } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import LightModePageTemplate from "../page/Templates/LightModeTemplate";
import SideBarTemplate from "../side-bar/SideBarTemplate";
import BulletinPanel from "../BulletinPanel/BulletinPanel";
import GridTitleCard from "../Cards/GridTitleCard";
import { faIdCard } from "@fortawesome/pro-solid-svg-icons";
import RightToWorkChecksGrid from "./RightToWorkChecksGrid";
import RightToWorkChecksSidePanel from "./RightToWorkChecksSidePanel";

interface RightToWorkChecksPageProps extends RouteComponentProps {
    title: string;
    category: string;
    location: any;
    queryId: string;
}

interface RightToWorkChecksPageState {
    rightToWorkCheckStatusId: string;
}

class RightToWorkChecksPage extends Component<RightToWorkChecksPageProps, RightToWorkChecksPageState> {
    state: RightToWorkChecksPageState;

    constructor(props: RightToWorkChecksPageProps) {
        super(props);
        this.state = {
            rightToWorkCheckStatusId: ""
        };
    }

     
    /**
     * Applies the selected Right To Work check status filter for grid reload.
     */
    onApplyButtonClick = (rightToWorkCheckStatusId: string) => {
        this.setState({
            rightToWorkCheckStatusId
        });
    };

     
    /**
     * Resolves the service type for route and hard-refresh scenarios.
     */
    getServiceTypeId = () => {
        if (this.props.location && this.props.location.state && this.props.location.state.serviceType) {
            return this.props.location.state.serviceType;
        }

        return sessionStorage.getItem("serviceTypeFilter") || "";
    };

    render() {
        return (
            <LightModePageTemplate>
                <SideBarTemplate isFixedDesktopOnly={true}>
                    <RightToWorkChecksSidePanel
                        onApplyButtonClick={this.onApplyButtonClick}
                    />
                    <BulletinPanel />
                </SideBarTemplate>
                <div className="page-content--with-sidebar-hidden-mobile">
                    <header className="grid-info mt-3 mb-3">
                        <GridTitleCard title="Right To Work Checks" icon={faIdCard} cardStyle="admin" />
                    </header>
                    <div className="row">
                        <div className="col-md">
                            <RightToWorkChecksGrid
                                rightToWorkCheckStatusId={this.state.rightToWorkCheckStatusId}
                                serviceTypeId={this.getServiceTypeId()}
                            />
                        </div>
                        <div></div>
                    </div>
                </div>
            </LightModePageTemplate>
        );
    }
}

export default withRouter(RightToWorkChecksPage);
